import { Col, Form, Row } from 'antd';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA } from '../../../../../contants/ClaimsEnums';
import {
  getLossAndDamageListInProgress,
  setLossAndDamageFilterType,
  setLossAndDamageFilters,
} from '../../../../../redux/Claims/LossAndDamage/LossAndDamageClaimsActions';
import { routeFileSelector } from '../../../../../utilz/i18n';
import Button from '../../../../components/Buttons/Button';
import Tab from '../../../../components/Tabs/Tab';
import { LOSS_AND_DAMAGE_FILTER_TYPES } from '../../constants';
import AdvancedFilters from './AdvancedFilters';
import BasicFilters from './BasicFilters';

const LossAndDamageFilters = () => {
  const dispatch = useDispatch();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const [filterForm] = Form.useForm();

  const { filterType, filters } = useSelector((state) => state.lossAndDamage);

  const handleTabChange = () => {
    if (filterType === LOSS_AND_DAMAGE_FILTER_TYPES.BASIC) {
      dispatch(setLossAndDamageFilterType(LOSS_AND_DAMAGE_FILTER_TYPES.ADVANCED));
    } else {
      dispatch(setLossAndDamageFilterType(LOSS_AND_DAMAGE_FILTER_TYPES.BASIC));
    }
  };

  useEffect(() => {
    if (filters) {
      filterForm.setFieldsValue(filters);
    }
  }, [filters]);

  const onSubmit = (data) => {
    dispatch(setLossAndDamageFilters({ ...data, pageNo: 1 }));
    dispatch(getLossAndDamageListInProgress());
  };

  const handleClear = () => {
    dispatch(setLossAndDamageFilters(LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA));
  };

  return (
    <div className="h-100 overflow-hidden d-flex flex-direction-column">
      <div className="flex-1 overflow-hidden">
        <Form className="h-100 overflow-hidden" form={filterForm} initialValues={filters} onFinish={onSubmit}>
          <Tab
            onChange={handleTabChange}
            contents={[
              {
                title: 'Basic',
                content: <BasicFilters filterForm={filterForm} />,
                contentKey: LOSS_AND_DAMAGE_FILTER_TYPES.BASIC,
              },
              {
                title: 'Advanced',
                content: <AdvancedFilters filterForm={filterForm} />,
                contentKey: LOSS_AND_DAMAGE_FILTER_TYPES.ADVANCED,
              },
            ]}
            defaultActiveKey={LOSS_AND_DAMAGE_FILTER_TYPES.BASIC}
            activeKey={filterType}
          />
        </Form>
      </div>
      <Row className="px-15 pt-15" gutter={15}>
        <Col sm={24} md={12}>
          <Button fullWidth type="default" onClick={handleClear} buttonType="button" id="shipment-filter-clear">
            {t('translation:default.buttons.clear')}
          </Button>
        </Col>
        <Col sm={24} md={12}>
          <Button
            fullWidth
            type="primary"
            onClick={() => filterForm.submit()}
            buttonType="submit"
            id="shipment-filter-search"
          >
            {t('translation:default.buttons.search')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default LossAndDamageFilters;
